import React from 'react'
// import DataLoader from "./Utils/DataLoader";
import { Link } from 'react-router-dom';
import DataLoader from '../../../Utils/DataLoader';
import Img from '../../../assets/images/rounded-shape-white.svg'

export default function BlogDemo({ blog, loader , visibleCount , onLoadMore}) {

     const visibleBlogs = blog.slice(0, visibleCount);

    return (
        <section className="section-equal-padding  deals_section blog_pages_sec uk-scrollspy-inview">
            <div className="container-fluid">
                <div className="row">
                    {loader ? (<div className='text-center'><DataLoader/></div>) : visibleBlogs.length > 0 ? (
                        visibleBlogs.map((ele, index) => (

                            <div className="col-sm-12 col-md-6 col-lg-4 col-xl-4 col-xxl-3 mb-4" key={index}>
                                <div className="blog-card uk-scrollspy-inview"
                                    uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                                    <figure>
                                        <img loading="lazy" src={ele?.image} alt="blogpost" className="img-fluid" />
                                    </figure>
                                    <div className="blog-content">
                                        <h3>{ele?.title}</h3>
                                    </div>
                                    <div className="blog-link">
                                        <span className="top-left"><img src={Img} /></span>
                                        <span className="bottom-right"><img src={Img}/></span>
                                        <Link to={`/single-blog/${ele?.slug}`}><i className="fa-solid fa-arrow-right"></i></Link>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <h3>No Blogs Found</h3>
                    )}

                </div>
                {visibleCount < blog.length && (
                    <div className="d-flex justify-content-center mt-4">
                        <button
                            className="view-all-btn w-auto"
                            onClick={onLoadMore}
                            disabled={loader}
                        >
                            {loader ? "Loading..." : "Load More"}
                        </button>
                    </div>
                )}
            </div>
        </section>
    )
}
